import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { BookingSheet } from "../components/BookingSheet";

export default function FissaPage({ session }) {
  const [selection, setSelection] = useState({});
  const [notice, setNotice] = useState("");
  const navigate = useNavigate();
  return <div className="page-content fissa-page" data-testid="page-fissa">
    <span className="section-label">FISSA</span>
    <h1 className="page-heading">Quale incontro fissare?</h1>
    {notice && <p className="venue-success" role="status" data-testid="fissa-success">{notice}</p>}
    <button className="hud-button" type="button" onClick={() => setSelection({})} data-testid="fissa-open-button">Fissa incontro +</button>
    <BookingSheet selection={selection} session={session} onClose={() => setSelection(null)}
      onBooked={() => setNotice("Incontro fissato.")} onAgenda={() => { setSelection(null); navigate("/agenda"); }} />
  </div>;
}